module.exports = __webpack_public_path__ + "img/animation.943b5186.gif";